import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { StarField } from "@/components/landing/StarField";
import { Services } from "@/components/landing/Services";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Marquee } from "@/components/landing/Marquee";
import { Pricing } from "@/components/landing/Pricing";
import { Reviews } from "@/components/landing/Reviews";
import { Privacy } from "@/components/landing/Privacy";
import { Faq } from "@/components/landing/Faq";
import { FinalCta } from "@/components/landing/FinalCta";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-[#0B0B1F] text-[#EDE6D3]">
      {/* Fixed nebula + stars behind every section, so the background reads as
          more than one flat navy tone while the page scrolls. */}
      <div className="cosmic-bg pointer-events-none fixed inset-0 z-0" aria-hidden="true" />
      <div className="cosmic-stars" aria-hidden="true">
        <StarField count={90} />
      </div>
      {/* Global grain overlay */}
      <div className="noise pointer-events-none fixed inset-0 z-[60] opacity-[0.04]" aria-hidden="true" />

      <Header />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <Marquee />
        <Pricing />
        <Reviews />
        <Privacy />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
